(function () {
  /**
   * Initializes the voucher code copy functionality.
   * Attaches event listeners for copying and resetting messages.
   */
  function initializeVoucherCopy() {
    const voucherCodeElements = document.querySelectorAll('.js-voucher-code');
    if (!voucherCodeElements.length) return;

    voucherCodeElements.forEach((voucherCodeElement, index) => {
      const voucherCodeValue = voucherCodeElement.querySelector('.js-voucher-code-value');
      const voucherCopyMessage = voucherCodeElement.querySelector('.js-voucher-tooltip__message');
      const voucherCopySuccess = voucherCodeElement.querySelector('.js-voucher-tooltip__success');

      // Attach event listeners
      voucherCodeElement.addEventListener('click', handleCopyToClipboard);
      voucherCodeElement.addEventListener('mouseleave', resetVoucherMessage);

      // Copies the voucher code to the clipboard.
      async function handleCopyToClipboard(event) {
        event.stopPropagation();
        const voucherCode = voucherCodeValue?.innerText.trim();

        if (!voucherCode) {
          return;
        }
        try {
          await navigator.clipboard.writeText(voucherCode);
          voucherCopyMessage.classList.add('hidden');
          voucherCopySuccess.classList.remove('hidden');
        } catch (error) {
          console.error(`Failed to copy voucher code ${voucherCode}:`, error.message);
        }
      }

      // Reset message on mouse leave
      function resetVoucherMessage() {
        voucherCopyMessage.classList.remove('hidden');
        voucherCopySuccess.classList.add('hidden');
      }
    });
  }

  // Initialize the voucher copy functionality
  initializeVoucherCopy();
})();
